import { Injectable } from '@angular/core';
import { BaseService } from '../base.service';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import { tap, catchError, map} from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { MinDTO } from 'src/app/models/min-dto';
import { SeaModel } from 'src/app/models/sea/sea-model';
import { MarketSeaProductsModel } from 'src/app/models/sea/market-sea-products.model';
import { v4 as uuidv4 } from 'uuid';
import { SseService } from '../sse-service';

@Injectable({
  providedIn: 'root'
})
export class SeaSearchService  extends BaseService<any>{

  constructor(public httpClient: HttpClient, public sseService: SseService) {
      super(
          'sea',
          httpClient);
  }

  search(seaModel: SeaModel): Observable<SeaModel> {
    let uri = new URL(environment.baseUrl + `/sea/search`);
    const uuid = uuidv4();
    localStorage.setItem("requestId", uuid);
    if(localStorage.getItem("requestId")) {
      this.sseService.connect(uuid);
    }
    const payload = { ...seaModel };

    if (payload.readinessDate) {
      const d = new Date(payload.readinessDate);
      const year = d.getFullYear();
      const month = (d.getMonth() + 1).toString().padStart(2, '0');
      const day = d.getDate().toString().padStart(2, '0');
      
      (payload as any).readinessDate = `${year}-${month}-${day}`;
    }

    payload.onlinePriceUuid= uuid;
    return this.httpClient.post<SeaModel>(uri.toString(), payload, { withCredentials: false, headers: this.httpHeaders() })
    .pipe(
    map((data: SeaModel) => {
      // sorting
      if (data && data.products) {

         if (data.readinessDate) {
            data.readinessDate = new Date(data.readinessDate);
         }

        data.products = data.products.sort((a, b) => {
          
          // 1. Gemi Sahibi (shipOwner) bilgisine göre sıralama
          if (a.shipOwner === null && b.shipOwner !== null) return 1; // null olanlar sona
          if (a.shipOwner !== null && b.shipOwner === null) return -1;
          if (a.shipOwner !== null && b.shipOwner !== null) {
            if (a.shipOwner < b.shipOwner) return -1;
            if (a.shipOwner > b.shipOwner) return 1;
          }
        
          // 2. shipOwner'lar aynıysa veya her ikisi de null ise fiyata (grandTotal) göre sıralama
          const grandTotalA = a.freights && a.freights.grandTotal !== null ? a.freights.grandTotal : Infinity;
          const grandTotalB = b.freights && b.freights.grandTotal !== null ? b.freights.grandTotal : Infinity;
        
          return grandTotalA - grandTotalB;
        });
      }
      return data; 
      }),
    catchError(this.handleError))
  }

  // get(marketOfferRequestsId: number): Observable<AirModel> {
  //   let uri = new URL(environment.baseUrl + `/air`).updateQueryParam({ id: marketOfferRequestsId });

  //   return this.httpClient.get<AirModel>(uri.toString(), { withCredentials: false, headers: this.httpHeaders() })
  //   .pipe(
  //     tap(),
  //     catchError(this.handleError)
  //   )
  // }

  segment(fromPortId: number, toPortId: number, fromCountryId: number, toCountryId: number): Observable<MinDTO> {
    let uri = new URL(environment.baseUrl + `/sea/segment`).updateQueryParam({ fromPortId, toPortId, fromCountryId, toCountryId });

    return this.httpClient.get<MinDTO>(uri.toString(), { withCredentials: false, headers: this.httpHeaders() })
    .pipe(
      tap(),
      catchError(this.handleError)
    )
  }

  discount(segmentId: number): Observable<string[]> {
    let uri = new URL(environment.baseUrl + `/sea/discount/${segmentId}`);
    return this.httpClient.get<string[]>(uri.toString(), { withCredentials: false, headers: this.httpHeaders() })
    .pipe(
      tap(),
      catchError(this.handleError)
    )
  }

  offer(seaModel): Observable<SeaModel> {
    let uri = new URL(environment.baseUrl + `/sea/offer`)

    return this.httpClient.post<SeaModel>(uri.toString(), seaModel, { withCredentials: false, headers: this.httpHeaders() })
    .pipe(
      tap(),
      catchError(this.handleError)
    )
  }

  getAiHint(body: any): Observable<any> {
    let uri = new URL(`${environment.baseUrl}/public/aihint/sea`)

    return this.httpClient.post<any>(uri.toString(), body, { withCredentials: false,  headers: this.httpHeaders() })
    .pipe(
      tap(),
      catchError(this.handleError)
    )
  }


      
  due(product: MarketSeaProductsModel, due: number, ref: string, id: number, cwg:number): Observable<MarketSeaProductsModel> {
    let uri = new URL(environment.baseUrl + `/sea/due`).updateQueryParam({ due, ref, id, cwg });
    
    return this.httpClient.post<MarketSeaProductsModel>(uri.toString(), product, { withCredentials: false, headers: this.httpHeaders() })
    .pipe(
      tap(),
      catchError(this.handleError)
    )
  }

    get(marketOfferRequestsId: number): Observable<SeaModel> {
        let uri = new URL(environment.baseUrl + `/sea`).updateQueryParam({ id: marketOfferRequestsId });

        return this.httpClient.get<SeaModel>(uri.toString(), { withCredentials: false, headers: this.httpHeaders() })
            .pipe(
                tap(),
                catchError(this.handleError)
            );
    }

    shipment(airModel): Observable<SeaModel> {
        let uri = new URL(environment.baseUrl + `/sea/shipment`);

        return this.httpClient.post<SeaModel>(uri.toString(), airModel, { withCredentials: false, headers: this.httpHeaders() })
            .pipe(
                tap(),
                catchError(this.handleError)
            )
    }

    insurance(seaModel): Observable<SeaModel> {
        let uri = new URL(environment.baseUrl + `/sea/insurance`);

        return this.httpClient.post<SeaModel>(uri.toString(), seaModel, { withCredentials: false, headers: this.httpHeaders() })
            .pipe(
                tap(),
                catchError(this.handleError)
            )
    }


     searchHistory(): Observable<SeaModel[]> {
      let uri = new URL(environment.baseUrl + `/sea/searchHistory`);
      return this.httpClient.get<SeaModel[]>(uri.toString(), { withCredentials: false, headers: this.httpHeaders() })
      .pipe(
        tap(),
        catchError(this.handleError)
      )
    }


  // shipment(airModel): Observable<AirModel> {
  //   let uri = new URL(environment.baseUrl + `/air/shipment`);

  //   return this.httpClient.post<AirModel>(uri.toString(), airModel, { withCredentials: false, headers: this.httpHeaders() })
  //   .pipe(
  //     tap(),
  //     catchError(this.handleError)
  //   )
  // }
  // insurance(airModel): Observable<AirModel> {
  //   let uri = new URL(environment.baseUrl + `/air/insurance`);

  //   return this.httpClient.post<AirModel>(uri.toString(), airModel, { withCredentials: false, headers: this.httpHeaders() })
  //   .pipe(
  //     tap(),
  //     catchError(this.handleError)
  //   )
  // }


}
